module.exports = __webpack_public_path__ + "img/Post_a_Job_inactive.f6b70e3a.svg";